import React from 'react';
import { getFontStyle } from '../../utils/getFontStyle';
import { getSecondaryColor } from '../../utils/activeColor';

interface ProfileDetailProps {
  icon?: React.ReactNode;
  label: string;
  value: string | string[] | undefined;
  onValueClick?: (value: string) => void;
}

const ProfileDetail: React.FC<ProfileDetailProps> = ({ icon, label, value, onValueClick }) => {
  if (!value) return null;

  const isClickable = typeof onValueClick === 'function';
  const values = Array.isArray(value) ? value : [value];

  return (
    <div className="profile-detail">
      <span
        className="profile-detail-key"
        style={getSecondaryColor() === 'white' ? { color: 'black' } : getFontStyle('')}
      >
        {label}
      </span>
      <div className="profile-detail-value" style={{ whiteSpace: 'pre-line' }}>
        {values.map((v, index) => (
          <div
            key={index}
            onClick={isClickable ? () => onValueClick(v) : undefined}
            style={isClickable ? { cursor: 'pointer', textDecoration: 'underline' } : {}}
          >
            {v}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileDetail;
